"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var uuid_1 = require("uuid");

var react_1 = require("@emotion/react");

var frontend_common_1 = require("@ryerson/frontend.common");

var RadioButtonContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpadding: 5px 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\tbox-sizing: border-box;\n\n\t", "\n"])), function (props) {
  var selectedColor = props.selectedColor;
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tinput[type=\"radio\"] {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t\topacity: 0;\n\t\t\t\tz-index: 1;\n\t\t\t\t:checked ~ span {\n\t\t\t\t\t:after {\n\t\t\t\t\t\ttransform: translateY(-50%) scale(1);\n\t\t\t\t\t}\n\t\t\t\t\t:before {\n\t\t\t\t\t\tborder-color: ", ";\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t:hover ~ span {\n\t\t\t\t\t:before {\n\t\t\t\t\t\tborder-color: ", ";\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t"])), selectedColor, selectedColor);
});
var DescriptionContainer = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tposition: relative;\n\tbox-sizing: border-box;\n\tmargin-top: 5px;\n\tpadding-left: 30px;\n"])));

var RadioButton = function RadioButton(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? (0, uuid_1.v4)() : _ref$id,
      value = _ref.value,
      name = _ref.name,
      className = _ref.className,
      label = _ref.label,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      onChange = _ref.onChange,
      dataTestId = _ref.dataTestId,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      inputRef = _ref.inputRef,
      description = _ref.description,
      sizeMobile = _ref.sizeMobile;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      borderColor = _theme$colors$primary.lightGray,
      primaryBrand = _theme$colors$primary.primaryBrand;
  var controlSize = 20;
  var fontSize = size === "sm" ? "sm" : "md"; // Adjust mobile size

  var _ref3 = (0, frontend_common_1.useWindowSize)(),
      _ref4 = _slicedToArray(_ref3, 1),
      width = _ref4[0];

  sizeMobile && width < parseInt(theme.breakpoints.lg) && (fontSize = size = sizeMobile);
  var labelColor = disabled ? theme.colors[type].disable : theme.colors[type].label;
  var descriptionColor = disabled ? theme.colors[type].disable : theme.colors[type].text;
  var selectedColor = disabled ? theme.colors[type].disable : primaryBrand;
  name = name ? name : value;
  label = label ? label : value;
  var RadioButton = styled_1.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\tcursor: ", ";\n\t\tposition: relative;\n\t\tbox-sizing: border-box;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tpadding-right: 30px;\n\t\twidth: ", "px;\n\t\theight: ", "px;\n\t\t:before {\n\t\t\tcontent: \"\";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\tbox-sizing: border-box;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t\twidth: ", "px;\n\t\t\theight: ", "px;\n\t\t\ttransition: transform 0.28s ease;\n\t\t\tborder-radius: 50%;\n\t\t\tborder: 1px solid ", ";\n\t\t}\n\n\t\t// circle in the center of the radio button\n\t\t:after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 4px;\n\t\t\twidth: ", "px;\n\t\t\theight: ", "px;\n\t\t\ttransform: scale(0);\n\t\t\ttransition: transform ease 0.25s;\n\t\t\tbackground: ", ";\n\t\t\tborder-radius: 50%;\n\t\t\tz-index: 2;\n\t\t\tcolor: ", ";\n\t\t}\n\t"])), disabled ? "default" : "pointer", controlSize, controlSize, controlSize, controlSize, borderColor, controlSize - 8, controlSize - 8, selectedColor, selectedColor);
  var Label = styled_1.default.label(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\tposition: relative;\n\t\tcursor: ", ";\n\t"])), disabled ? "default" : "pointer");

  var handleOnChange = function handleOnChange(event) {
    if (!disabled) {
      onChange(event.target.value);
    }
  };

  var handleOnContainerKeyPress = function handleOnContainerKeyPress(event) {
    if (!disabled) {
      if (event.key === "Enter") {
        event.stopPropagation();
        var element = document.getElementById(id);

        if (element) {
          element.click();
        }
      }
    }
  };

  var fontStyle = (0, react_1.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\tcolor: ", ";\n\t\t", ";\n\t"])), labelColor, !disabled && "\n\t\t\t:hover {\n\t\t\t\tcolor: ".concat(selectedColor, ";\n\t\t\t}\n\t\t"));
  return (0, jsx_runtime_1.jsxs)(RadioButtonContainer, {
    onKeyDown: handleOnContainerKeyPress,
    tabIndex: disabled ? -1 : 0,
    selectedColor: selectedColor,
    children: [(0, jsx_runtime_1.jsxs)(Label, {
      htmlFor: id,
      children: [(0, jsx_runtime_1.jsx)("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        checked: checked,
        onChange: handleOnChange,
        className: className,
        "data-testid": dataTestId,
        "aria-disabled": disabled ? true : false,
        ref: inputRef
      }), (0, jsx_runtime_1.jsx)(RadioButton, {}), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        css: fontStyle,
        size: fontSize,
        children: label
      })]
    }), description && (0, jsx_runtime_1.jsx)(DescriptionContainer, {
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        color: descriptionColor,
        size: fontSize,
        children: description
      })
    })]
  });
};

exports.default = RadioButton;